<template>
  <li style="list-style: none;" class="tree-filter-item">
    <div class="item-block"
         :class="{'filter-tree-selected': selectedOrganization.id == item.id}"
         @click="$emit('updateSelected', item)"
         v-if="showDepartmentItem(item)"
    >
      <span @click="toggle" class="tree-filter-item-toggle" v-if="item.children && item.children.length">
        <font-awesome-icon icon="caret-right" v-if="!isOpen" />
        <font-awesome-icon icon="caret-down" v-if="isOpen" />
      </span>
      <span class="tree-filter-item-toggle" v-if="!item.children.length">
        &nbsp;
      </span>
      <span class="cursor-pointer" :title="item.name">
        <font-awesome-icon icon="sitemap"/>
        {{ item.name }}
      </span>
    </div>
    <ul v-show="isOpen" class="tree-filter-list">
      <OrganizationTreeFilterItem
        v-for="(child, index) in item.children"
        :key="index"
        @updateSelected="$emit('updateSelected', $event)"
        :item="child"
        :level="level+1"
        :ids="ids"
        :expandedIds="expandedIds"
        :selectedOrganization="selectedOrganization"
      ></OrganizationTreeFilterItem>
    </ul>
  </li>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import roleCheck from "@/util/ACL/roleCheck"
import OrganizationTreeFilterItem from '@/components/organizations/OrganizationTreeFilterItem.vue';

export default {
  name: 'OrganizationTreeFilterItem',
  data: function() {
    return {
      isOpen: false
    }
  },
  props: {
    item: Object,
    selectedOrganization: Object,
    level: {},
    ids: {},
    expandedIds: {}
  },
  watch: {
    selectedOrganization: function () {

    },
    expandedIds: function () {
      this.expandDepartmentItem(this.item)
    }
  },
  components: {
    OrganizationTreeFilterItem
  },
  computed: {

  },
  methods: {
    toggle: function () {
      this.isOpen = !this.isOpen
    },
    showDepartmentItem(object) {
      let found = false

      if (roleCheck('Member')) {
        if (object.id == this.ids[this.level-1] || _.indexOf(this.ids, object.id) > this.level-1) {
          found = true;
        }
      } else {
        found = true;
      }

      return found;
    },
    expandDepartmentItem(object) {
      if (object.id == this.expandedIds[this.level-1]) {
        this.isOpen = true;
      }
    }
  },
  created () {
    this.isOpen = this.item.organization_level == 1
    this.expandDepartmentItem(this.item)
  }
}
</script>
